<script>
  import ChangeStatus from './ChangeStatus.vue'
  import Service from '../../../../domain/leiloes/services/pregao'
  import {number_format as numberFormat} from '../../../../utils/helpers/phpjs'
  import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'
  export default{
    name: 'u-keyboard',
    props: ['startShow'],
    data () {
      return {
        show: this.startShow
      }
    },
    created () {
      /* document.addEventListener('keyup', (pKey) => {
       console.log(pKey)
       }) */
    },
    computed: {
      Status () {
        return Status
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      toggleKeyboard () {
        this.show = !this.show
        this.$emit('toggle', this.show)
      },

      anterior () {
        console.log('Trocando lote para o anterior...')
        this.$refs.changeStatus.open('Mudando para Lote Anterior')
        Service.voltarLote(this.$route.params.id)
          .then((response) => {
            this.$refs.changeStatus.close()
            this.$emit('mudarLote', {acao: 'voltar', lote: response.data.lote, pregao: response.data.pregao})
          })
          .catch((response) => {
            this.$refs.changeStatus.close()
            console.log(Number(response.status))
            if (Number(response.status) === 401) {
              window.alert('Não há mais lotes para avançar')
              return
            }
            window.alert('Erro ao mudar de lote. Tente novamente, caso o erro persista, contate o administrador do sistema.')
            console.log(response)
          })
      },

      proximo () {
        console.log('Trocando lote para o próximo...')
        this.$refs.changeStatus.open('Mudando para Próximo Lote')
        Service.avancarLote(this.$route.params.id)
          .then((response) => {
            this.$refs.changeStatus.close()
            this.$emit('mudarLote', {acao: 'avancar', lote: response.data.lote, pregao: response.data.pregao})
          })
          .catch((response) => {
            this.$refs.changeStatus.close()
            if (Number(response.status) === 401) {
              window.alert('Não há mais lotes para avançar')
              return
            }
            window.alert('Erro ao mudar de lote. Tente novamente, caso o erro persista, contate o administrador do sistema.')
            console.log(response)
          })
      },

      deletarLance () {
        console.log('Deletando último lance...')
        if (typeof this.$parent.lote.lances[0] === 'undefined') {
          window.alert('Nenhum lance para apagar')
          return
        }
        let lance = this.$parent.lote.lances[0]
        this.$confirm.open('Tem certeza que deseja deletar o lance de ' + lance.arrematante.apelido + ' no valor de R$ ' + numberFormat(lance.valor, 2, ',', '.') + '?', {
          message: 'Deletar',
          color: 'btn-danger'
        }, 'Cancelar', null, (v) => {
          if (v === false) {
            return
          }
          console.log('Deletando lance ' + lance.id + '...')
          this.$refs.changeStatus.open('Deletando Lance')
          Service.deletarLance(lance.id)
            .then((response) => {
              this.$refs.changeStatus.close()
              this.$emit('deletarLance', lance)
            })
            .catch((response) => {
              this.$refs.changeStatus.close()
              window.responseError(response)
              console.log(response)
            })
        })
      },

      loteStatus (s, lote) {
        if (typeof lote === 'undefined') {
          lote = this.$parent.lote.id
        }
        this.$confirm.open('Tem certeza que deseja alterar o status do lote para ' + Status.StatusTitle(s) + '?', 'Alterar Status para ' + Status.StatusTitle(s), 'Cancelar', null, (v) => {
          if (v === false) {
            return
          }
          console.log('Trocando status do lote para ' + s + '...')
          this.$refs.changeStatus.open('Alterando status do lote')
          Service.alteraStatusLote(this.$route.params.id, lote, s)
            .then((response) => {
              this.$refs.changeStatus.close()
              this.$emit('statusLote', response.data.lote)
            })
            .catch((response) => {
              this.$refs.changeStatus.close()
              window.responseError(response)
              console.log(response)
            })
        })
      },
      lanceManual (valor) {
        console.log('Efetuando lance manual...')
        this.$refs.changeStatus.open('Efetuando lance')
        Service.lancePlateia(this.$route.params.id, this.$parent.lote.id, valor)
          .then((response) => {
            this.$refs.changeStatus.close()
            this.$emit('novoLance', response.data.lote, response.data.lance)
          })
          .catch((response) => {
            this.$refs.changeStatus.close()
            window.responseError(response)
            console.log(response)
          })
      },
      doulheUma () {
        console.log('Alterando status do lote para Dou-lhe Uma...')
      },
      doulheDuas () {
        console.log('Alterando status do lote para Dou-lhe Duas...')
      },
      baixaOferta () {
        console.log('Alterando status do lote para Baixa Oferta...')
      },
      semLicitantes () {
        console.log('Alterando status do lote para Sem Licitantes...')
      },
      homologando () {
        console.log('Homologando...')
      },
      condicional () {
        console.log('Alterando status do lote para Condicional...')
      },
      vendido () {
        console.log('Alterando status do lote para Vendido...')
      },
      focusMe () {
        this.$refs.focusme.focus()
      }
    },
    components: {
      ChangeStatus
    }
  }
</script>

<template>
  <div>
    <a ref="focusme" style="width: 0; height: 0"></a>
    <change-status ref="changeStatus"></change-status>
    <div class="keyboard" :class="{khide: !show}">
      <a class="toggle" @click="toggleKeyboard"></a>
      <div class="buttons">
        <a class="control-anterior" v-shortkey="['arrowleft']" @shortkey="anterior"
           @click="anterior">Anterior <i>&larr;</i></a>
        <a class="control-proximo" v-shortkey="['arrowright']" @shortkey="proximo" @click="proximo">Próximo <i>
          &rarr;</i></a>
        <a class="control-deletar-lance" v-shortkey="['delete']"
           @shortkey="deletarLance" @click="deletarLance">Deletar Lance <i>Delete</i></a>
        <a class="control-aberto" v-shortkey="['1']" @shortkey="loteStatus(Status.STATUS_ABERTO_PARA_LANCES)"
           @click="loteStatus(Status.STATUS_ABERTO_PARA_LANCES)">Aberto <i>1</i></a>
        <a class="control-pregao" v-shortkey="['2']" @shortkey="loteStatus(Status.STATUS_EM_PREGAO)"
           @click="loteStatus(Status.STATUS_EM_PREGAO)">Em Pregão <i>2</i></a>
        <a class="control-incremento" v-shortkey="['+']" @shortkey="lanceManual(0)"
           @click="lanceManual(0)">Incremento <i>+</i></a>
        <a class="control-dolheuma" v-shortkey="['3']" @shortkey="loteStatus(Status.STATUS_DOULHE_UMA)"
           @click="loteStatus(Status.STATUS_DOULHE_UMA)">Dou-lhe Uma <i>3</i></a>
        <a class="control-doulheduas" v-shortkey="['4']" @shortkey="loteStatus(Status.STATUS_DOULHE_DUAS)"
           @click="loteStatus(Status.STATUS_DOULHE_DUAS)">Dou-lhe Duas <i>4</i></a>
        <a class="control-baixaoferta" v-shortkey="['0']" @shortkey="loteStatus(Status.STATUS_BAIXA_OFERTA)"
           @click="loteStatus(Status.STATUS_BAIXA_OFERTA)">Rejeitado <i>0</i></a>
        <a class="control-semlicitantes" v-shortkey="[',']" @shortkey="loteStatus(Status.STATUS_SEM_LICITANTES)"
           @click="loteStatus(Status.STATUS_SEM_LICITANTES)">Sem Licitantes <i>,</i></a>
        <a class="control-homologando" v-shortkey="['*']" @shortkey="loteStatus(Status.STATUS_HOMOLOGANDO)"
           @click="loteStatus(Status.STATUS_HOMOLOGANDO)">Homologando <i>*</i></a>
        <a class="control-condicional" v-shortkey="['9']" @shortkey="loteStatus(Status.STATUS_CONDICIONAL)"
           @click="loteStatus(Status.STATUS_CONDICIONAL)">Condicional <i>9</i></a>
        <a class="control-vendido" v-shortkey="['.']" @shortkey="loteStatus(Status.STATUS_VENDIDO)"
           @click="loteStatus(Status.STATUS_VENDIDO)">Vendido <i>.</i></a>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Keyboard.vue?045af990